var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loading",staticClass:"el-loading-mask pageloading"},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }